import { useUserPermissionStore } from "@/stores/user-permission-store";
import { getMarkStatus } from "@/services/UtilitiesService";
import { useAnnotationStore } from "@/stores/annotation-store";

import type { ParsedMark } from "@/models/Mark";

interface MarkDefault {
  borderColor: string;
  fillColor: string;
  opacity: number;
}

export const markDefaults: Record<string, MarkDefault> = {
  user: {
    borderColor: "#FFFF00",
    fillColor: "#FFFF00",
    opacity: 120,
  },
  candidate: {
    borderColor: "#f7941d",
    fillColor: "#f7941d",
    opacity: 100,
  },
  ai: {
    borderColor: "#E5DEDE",
    fillColor: "#E5DEDE",
    opacity: 40,
  },
  rejected: {
    borderColor: "#fc8181",
    fillColor: "#fc8181",
    opacity: 100,
  },
  accepted: {
    borderColor: "#FFFF00",
    fillColor: "#FFFF00",
    opacity: 100,
  },
  ["RectangleAnnotation"]: {
    borderColor: "#FFFF00",
    fillColor: "#FFFF00",
    opacity: 100,
  },
  ["RectangleRedaction"]: {
    borderColor: "#000",
    fillColor: "#000",
    opacity: 255,
  },
  ["HighlightAnnotation"]: {
    borderColor: "#FFFF00",
    fillColor: "#FFFF00",
    opacity: 100,
  },
  ["HighlightRedaction"]: {
    borderColor: "#000",
    fillColor: "#000",
    opacity: 255,
  },
  ["SelectText"]: {
    borderColor: "#000FFF",
    fillColor: "#000FFF",
    opacity: 50,
  },
};

export function isRedaction(mark: { type: string | undefined }) {
  return /redact/i.test(mark.type ?? "");
}

function isAllowedToUpdate(annotation: ParsedMark) {
  const canRedact = useUserPermissionStore().userPermission.canRedact;
  const canAnnotate = useUserPermissionStore().userPermission.canAnnotate ?? false;

  const status = getMarkStatus(annotation);

  if (!canAnnotate || annotation.parsedMarkData == null) return false;
  if (isRedaction(annotation.parsedMarkData as { type: string }) && !canRedact) return false;
  if (!/user|accepted|candidate|ai/i.test(status)) return false;

  return true;
}

export async function deleteAnnotation(parsedAnnotation: ParsedMark) {
  if (!isAllowedToUpdate(parsedAnnotation)) return;
  return useAnnotationStore().delete({ annotation: parsedAnnotation });
}

export async function saveAnnotation(parsedAnnotation: ParsedMark) {
  if (!isAllowedToUpdate(parsedAnnotation)) return;
  await useAnnotationStore().save({ annotation: parsedAnnotation });
}
